import ApiService from "./api.service";
import mainStore from "../store/mainStore";

class PlaceholderService extends ApiService {
    async GetAll() {
        let response = await this.get("api/meeting/placeholder");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }
        mainStore.commit('setAvailablePlaceholders', response.data)
    }

    async Delete(id){
        let response = await this.delete(`api/meeting/placeholder/${id}`);
        if(response.status !== 204){
            throw await Promise.reject(response);
        }
        await this.GetAll();
    }

    async Create(data){
        let response = await this.post("api/meeting/placeholder", data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if(response.status !== 200){
            throw await Promise.reject(response);
        }

        await this.GetAll();
    }

    async Update(id, data){
        let response = await this.put(`api/meeting/placeholder/${id}`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        
        if(response.status !== 200){
            throw await Promise.reject(response);
        }

        await this.GetAll();
    }
}

export default new PlaceholderService();